import apiClient from '@shared/services/apiClient';

export interface ClinicMetrics {
  totalClinics: number;
  activeClinics: number;
  inactiveClinics: number;
  clinicsNeedingVerification: number;
  overdueVerifications: number;
  verificationSettings: {
    verificationPeriodDays: number;
    warningDays: number;
  };
  // Capability metrics
  clinicsWithPAT?: number;
  clinicsWithXRay?: number;
  clinicsWithFitTesting?: number;
}

export const dashboardApi = {
  getClinicMetrics: async (): Promise<ClinicMetrics> => {
    const response = await apiClient.get('/dashboard/clinic-metrics');
    return response.data;
  },
};
